import React, { CSSProperties, useEffect, useRef, useState } from 'react';
import { useDroppable } from '@dnd-kit/core';
import { Height } from '@mui/icons-material';
import { overflow } from 'html2canvas/dist/types/css/property-descriptors/overflow';
import { overflowWrap } from 'html2canvas/dist/types/css/property-descriptors/overflow-wrap';
import './index.css';
type DroppableItemProps = {
  children: React.ReactNode;
  id: string;
  rows?: any;
};

const Droppable = ({ id, children, rows }: DroppableItemProps) => {
  const { setNodeRef, isOver } = useDroppable({
    id
  });

  const containerRef = useRef<HTMLDivElement>(null);
  const prevRowsLengthRef = useRef(rows.length);

  const findTableContainer = () => {
    if (containerRef.current) {
      return containerRef.current.querySelector('.MuiTableContainer-root');
    }
    return null;
  };

  const scrollToBottom = () => {
    setTimeout(() => {
      const tableContainer = findTableContainer();
      if (tableContainer) {
        tableContainer.scrollTop = tableContainer.scrollHeight;
      }
    }, 50);
  };

  useEffect(() => {
    if (rows.length > prevRowsLengthRef.current) {
      scrollToBottom();
    }
    prevRowsLengthRef.current = rows.length;
  }, [rows.length]);

  useEffect(() => {
    if (!isOver && rows.length > prevRowsLengthRef.current) {
      scrollToBottom();
    }
  }, [isOver, rows.length]);

  const containerStyle: CSSProperties = {
    position: 'relative',
    transition: 'border 0.3s ease',
    marginTop: '5px',
    height: '100%',
    border: isOver ? '2px dotted #000' : '2px solid transparent'
  };

  return (
    <div
      ref={containerRef}
      style={containerStyle}
    >
      <div ref={setNodeRef}>
        {children}
      </div>
    </div>
  );
};

export default Droppable;
